import { uuid } from '../utils';
import {
  ILLUSTRATION
} from './categories';

export default {
  id: uuid(),
  priority: 7,
  name: 'Backgrounds',
  thumbnail: './Backgrounds/Bkg_Thumb.jpg',
  categories: [ ILLUSTRATION ],
  content: [
    './Backgrounds/LS_gradina.jpg',
    './Backgrounds/LS_nterior.jpg',
    './Backgrounds/LS_Dormitor.jpg',
    './Backgrounds/LS_drum_asfintit.jpg',
    './Backgrounds/LS_Sat_pan1.jpg',
    './Backgrounds/LS_SAt_pan2.jpg',
    './Backgrounds/FiareVechi.jpg',
    './Backgrounds/dupa-bloc.jpg',
    './Backgrounds/BdUnirii.jpg',
    './Backgrounds/pta-Rev.jpg',
    './Backgrounds/moto-gunoi.jpg',
    './Backgrounds/AP_Est_Duel1.jpg',
    './Backgrounds/AP_Oz_lan.jpg',
    './Backgrounds/Basferatu_Gradina.jpg',
    './Backgrounds/Wudang.jpg',
    './Backgrounds/Hotel.jpg',
    './Backgrounds/Basferatu_SediuConsp.jpg',
    './Backgrounds/Interior_intreg.jpg',
    './Backgrounds/masa_de_lucru.jpg',
    './Backgrounds/compoz.Lat.jpg',
    './Backgrounds/Vehicle_views.jpg',
    './Backgrounds/Vehicles.jpg',
    './Backgrounds/Planes.jpg',
    './Backgrounds/Masini3.jpg',
    './Backgrounds/locomotiva1.jpg'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/backgrounds.js